import { render, staticRenderFns } from "./subscription-section.vue?vue&type=template&id=5d55a7a5&scoped=true&"
import script from "./subscription-section.vue?vue&type=script&lang=js&"
export * from "./subscription-section.vue?vue&type=script&lang=js&"
import style0 from "./subscription-section.vue?vue&type=style&index=0&id=5d55a7a5&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d55a7a5",
  null
  
)

export default component.exports